import isbot from 'isbot';

export const isWebCrawler = (): boolean => {
  return isbot(navigator.userAgent);
};
